export default __webpack_public_path__ + "static/media/15.02330e96.jpeg";